import React from "react";

export const RenderContext = React.createContext({
  base: null,
  host: null,
  href: null,
  location: null,
  pathname: null,
  port: null,
  scheme: null,
  search: null,
  serverSide: false,
});
